import * as ActionTypes from "services/state/action-types";
import _filter from "lodash/filter";
import { parse } from "services/utils/date";
import moment from "moment";
moment.locale("pt-br");

const FREE_CALLS_INITIAL_STATE = {
  loading: false,
  error: false,
  freecallsList: [],
  freecallsFiltered: [],
  pdfUrlDownloader: null,
};

const filterByDate = (freecallsList, { startDate, endDate }) => {
  const dateFiltered = _filter(freecallsList, (item) => {
    const normalizedDate = parse(item.dueDate);
    return moment(normalizedDate).isBetween(startDate, endDate, null, "[]");
  });
  return dateFiltered;
};

export const freecalls = (state = FREE_CALLS_INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.GET_FREE_CALLS:
      return { ...state, loading: true };

    case ActionTypes.GET_FREE_CALLS_SUCCESS:
      return {
        ...state,
        loading: false,
        freecallsList: action.payload,
        freecallsFiltered: action.payload,
      };

    case ActionTypes.GET_FREE_CALLS_FAIL:
      return { ...state, loading: false, error: true };

    case ActionTypes.FILTER_FREE_CALLS:
      return {
        ...state,
        freecallsFiltered: filterByDate(state.freecallsList, action.payload),
      };

    case ActionTypes.DOWNLOAD_FREE_CALLS_DETAILS:
      return { ...state, loading: true };

    case ActionTypes.DOWNLOAD_FREE_CALLS_DETAILS_SUCCESS:
      return { ...state, loading: false, pdfUrlDownloader: action.payload };

    case ActionTypes.DOWNLOAD_FREE_CALLS_DETAILS_FAIL:
      return { ...state, loading: false, error: true };

    case ActionTypes.SEND_FREE_CALLS_EMAIL:
      return { ...state, loading: true };

    case ActionTypes.SEND_FREE_CALLS_EMAIL_SUCCESS:
      return { ...state, loading: false };

    case ActionTypes.SEND_FREE_CALLS_EMAIL_FAIL:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/services/state/freecalls/reducer.js